import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1c62ad',
        secondary: '#878886',
        gris: '#EEEEEE',
        gris2: '#f3f3f3',
        gris3: '#666',
      },
    },
  },
});
